// @flow

import CompanyComboBox from './components/CompanyComboBox';

export const components = {
    'formPaneField:COMPANY': CompanyComboBox
}
